import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function articlesReducer(state = initialState.articles, action) {
    let newState;
    switch (action.type) {
        case types.LOAD_ARTICLES_SUCCESS:
            return action.articles;
            break;
        case types.DELETE_ARTICLE_SUCCESS:
            newState = {...state};
            newState.data = newState.data.filter(article => article.id !== action.id);
            newState.total = newState.total - 1;
            return newState;
            break;
        case types.CLONE_ARTICLE_SUCCESS:
            let copiedArticle = action.article;
            const total = state.total;

            const data = state.data;
            data.push(copiedArticle);

            newState = Object.assign({}, state);
            newState.data = data;
            newState.total = total+1;
            return newState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/articlesReducer.js